import { Box } from '../Box'
import { visuallyHidden } from '../util.css'
import { Checkbox, type CheckboxProps } from './Checkbox'
import {
  toggleStyle,
  toggleCheckboxStyle,
  smallToggleInput,
  mediumToggleInput,
} from './Toggle.css'

const inputSizes = {
  small: smallToggleInput,
  medium: mediumToggleInput,
} as const

/** @deprecated */
export type ToggleProps = {
  size?: keyof typeof inputSizes
} & Omit<CheckboxProps, 'size'>

/** @deprecated */
export const Toggle = ({
  children,
  size = 'small',
  className,
  ...props
}: ToggleProps) => {
  return (
    <Checkbox
      {...props}
      className={[toggleCheckboxStyle, className]}
      inputClassName={visuallyHidden}
      fontSize="12"
      unstyled
      unspaced
    >
      {/* Use separate element for slider/toggle, so we can re-use atoms. Alternatively we could style checkbox with pseudos */}
      <Box
        aria-hidden="true"
        as="span"
        className={[toggleStyle, inputSizes[size]]}
      />
      {children}
    </Checkbox>
  )
}
